export const useSubdomain = () =>
  useState<string | undefined>("subdomain", () => undefined);
